import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import { Modules } from "../../../constants/Module";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { DeliverableStatus, ProjectStatuses } from "../../../constants/Status";
import moment from "moment";
import { withTranslation } from "react-i18next";
function SuccessStory({ item, t}) {
  return (
    <div>
      <div>
        <strong>
          {" "}
          {ucFirst(Modules.SUCCESS_STORY)} ({typeof item?.payload?.name === 'object' ? item?.payload?.name.old : item?.payload?.name}){" "}
        </strong>
         {item.event === Action.CREATE ? t("was added to") : item.event === Action.UPDATE ? t("was updated for") : t("was deleted from")}{" "}
        <strong>
          {t('startup')} {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        {t('by')}
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
      {item?.event === Action?.UPDATE && (
        <div>
          {typeof item?.payload?.name === 'object' &&
            item?.payload?.name?.old &&
            item?.payload?.name?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Name')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.name?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.name?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.description === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Description')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.description?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.description?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
export default withTranslation()(SuccessStory);